// ===== Interfaces =====

import {
    IPostContentTarget,
    IReadPostItem,
}                               from '../interfaces';

// ===== Enums =====

import {
    POST_CONTENT_SCOPE,
}                               from '../enums';

// ** IMPORTANT **: Keep in sync with functions/src/index.ts/buildPostCollabDocId
const buildPostContentDocId = ({
    postId,
    scope,
    chapterId,
    sectionId,
}: {
    postId: string,
    scope: IPostContentTarget['scope'],
    chapterId?: string,
    sectionId?: string,
}): string | undefined => {
    if (scope === POST_CONTENT_SCOPE.root) {
        return `${postId}::${POST_CONTENT_SCOPE.root}`;
    }
    if (scope === POST_CONTENT_SCOPE.chapter && chapterId) {
        return `${postId}::${POST_CONTENT_SCOPE.chapter}:${chapterId}`;
    }
    if (scope === POST_CONTENT_SCOPE.section && sectionId) {
        return `${postId}::${POST_CONTENT_SCOPE.section}:${sectionId}`;
    }
    return undefined;
};

const resolvePostContentTarget = ({
    postId,
    post,
    path,
}: {
    postId: string | null,
    post?: IReadPostItem,
    path: number[],
}): IPostContentTarget => {
    const normalizedPath = Array.isArray(path) ? path.slice(0, 2) : [];
    const chapterIndex = normalizedPath.length > 0 ? normalizedPath[0] : undefined;
    const sectionIndex = normalizedPath.length > 1 ? normalizedPath[1] : undefined;

    if (chapterIndex != null && sectionIndex != null) {
        const chapter = post?.chapters?.[chapterIndex];
        const section = chapter?.sections?.[sectionIndex];
        const docId = postId != null
            ? buildPostContentDocId({
                postId,
                scope: POST_CONTENT_SCOPE.section,
                chapterId: chapter?.id,
                sectionId: section?.id,
            })
            : undefined;
        return {
            postId,
            path: normalizedPath,
            scope: POST_CONTENT_SCOPE.section,
            chapterId: chapter?.id,
            sectionId: section?.id,
            docId,
            roomId: docId,
            isResolved: docId != null,
        };
    }

    if (chapterIndex != null) {
        const chapter = post?.chapters?.[chapterIndex];
        const docId = postId != null
            ? buildPostContentDocId({
                postId,
                scope: POST_CONTENT_SCOPE.chapter,
                chapterId: chapter?.id,
            })
            : undefined;
        return {
            postId,
            path: normalizedPath,
            scope: POST_CONTENT_SCOPE.chapter,
            chapterId: chapter?.id,
            docId,
            roomId: docId,
            isResolved: docId != null,
        };
    }

    const docId = postId != null
        ? buildPostContentDocId({
            postId,
            scope: POST_CONTENT_SCOPE.root,
        })
        : undefined;
    return {
        postId,
        path: [],
        scope: POST_CONTENT_SCOPE.root,
        docId,
        roomId: docId,
        isResolved: docId != null,
    };
};

export default resolvePostContentTarget;
